import { queryFirst } from "./domUtil";

function toggleCollapseState() {
    const collapseSelector = '.js-acc-collapse';
    const containerSelector = '.accordion-container';
    const expandedClass = 'm-expanded';
    const expandedAllClass = 'm-expanded-all';
    const $collapseEl = $(collapseSelector);


    $('.js-expand-all').on('click', function () {
        $(this).closest(containerSelector).addClass(expandedAllClass);
    });

    $collapseEl.on('shown.bs.collapse', function () {
        const $collapseContainer = $(this).closest(containerSelector);

        if (!$collapseContainer.find(collapseSelector).not('.show').length) {
            $collapseContainer.addClass(expandedAllClass);
        } else if (!$collapseContainer.hasClass(expandedClass)) {
            $collapseContainer.addClass(expandedClass);
        }
    });

    $collapseEl.on('hidden.bs.collapse', function () {
        const $collapseContainer = $(this).closest(containerSelector);

        if (!$collapseContainer.find(collapseSelector).is('show').length) {
            $collapseContainer.removeClass(expandedAllClass);
        }

        if (!$collapseContainer.find(collapseSelector).hasClass('show') && $collapseContainer.hasClass(expandedClass)) {
            $collapseContainer.removeClass(expandedClass);
        }
    });
}

$(document).ready(function () {
    var searchUrl = window.location.search;
    const listParams = new URLSearchParams(searchUrl);
    const retailstore = listParams.get('retailstore');
    if (retailstore && retailstore === 'true') {
        const retailTab = queryFirst('.js-retailstore');
        $(retailTab).trigger('click');
        const targetElement = queryFirst('.in-storepickup');
        $(targetElement).trigger('click').focus();
    }

    toggleCollapseState();
})
